export default __webpack_public_path__ + "static/media/6t.b32b2944.jpg";